import { createSlice } from '@reduxjs/toolkit'
import { st8LaunchGame, st8Withdraw } from 'redux-thunk/thunk/st8.thunk'

const initialState = {
  gameUrl: null,
  walletToken: null,
  depositedAmount: null,
  loading: false,
  error: null
}

const {
  actions: { resetSt8State },
  reducer
} = createSlice({
  name: 'st8',
  initialState,
  reducers: {
    resetSt8State: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(st8LaunchGame.pending, (state) => ({
        ...state,
        loading: true,
        error: null
      }))
      .addCase(st8LaunchGame.fulfilled, (state, action) => ({
        ...state,
        loading: false,
        gameUrl: action.payload?.gameUrl,
        walletToken: action.payload?.walletToken,
        depositedAmount: action.payload?.depositedAmount
      }))
      .addCase(st8LaunchGame.rejected, (state, action) => ({
        ...state,
        loading: false,
        error: action.payload
      }))
      .addCase(st8Withdraw.fulfilled, (state) => ({
        ...state,
        walletToken: null,
        gameUrl: null,
        depositedAmount: null
      }))
  }
})

export { resetSt8State }
export default reducer
